<div class="userSettingPages">
  <div class="scufa-info-container" *ngIf="showInfoContainer">
    <div class="scufa-info-row">
      <!-- <div class="scufa-info-row-left" *ngIf="showBackButton">
        <div class="left-svg"><div class="svg-back-circle"></div></div>

      </div> -->
      <div class="scufa-info-row-right-list">
        <div class="sub-info-row-item">
          {{ 'Lugas_Text_29' | t }}

          <div class="list-item-container">
            <div class="list-item">
              <div class="dot"></div>
              {{ 'Lugas_Text_30' | t }}
            </div>
            <div class="list-item">
              <div class="dot"></div>
              {{ 'Lugas_Text_31' | t }}
            </div>
          </div>

          <div style="margin-top: 10px">
            {{ 'Lugas_Text_32' | t }}
            <a class="contact-support" (click)="OpenAccountMobile(6)">{{ 'Lugas_Text_33' | t }} </a>

            {{ 'Lugas_Text_34' | t }}
          </div>
        </div>

        <!-- <span>
          {{'Lugas_Text_15' | t}} <a class="contact-support" (click)="OpenAccountMobile(6)"> {{'Lugas_Text_16' | t}}
          </a> {{'Lugas_Text_17' | t}} <a class="contact-support" target="_blank" [href]="'contactUrl' | getEnv"> {{'Lugas_Text_12' | t}}
          </a>  {{'Lugas_Text_13' | t}}

        </span> -->
      </div>
    </div>
  </div>
  <ng-container [ngSwitch]="['b500'] | getProductName">
    <ng-container *ngSwitchCase="'b500'"></ng-container>
    <ng-container *ngSwitchDefault>
      <div class="document-upload-main-container text" *ngIf="!hasInsicToken">
        <div class="document-info-text">
          {{ 'errorinsictoken' | t }}
        </div>
      </div>
      <div id="___avs-wrapper" style="height: 516px; margin-top: 10px"></div>
    </ng-container>
  </ng-container>
</div>
